import getFetchOptions from 'utils/getFetchOptions';

import { handleResponse } from '../utils';
import { Industry } from './industries.types';

export const getIndustries = async (apiAprilBaseUri: string): Promise<Array<Industry>> => {
  const options = await getFetchOptions('GET');

  return await fetch(`${apiAprilBaseUri}/merchants/industries`, options).then(handleResponse);
};
